import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/contact/components/ContactInquiryPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/sustainability/client/SustainabilityLandingClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/sections/Products/FaqEnquiryGrid.tsx");
